export default {
  disclaimer: '免責聲明',
  privacy_policy_statement: '私隱與政策',
  security_information: '保安資訊',
  risk_disclosure_statement: '風險披露聲明',
  telephone: '諮詢電話'
}
